export default __webpack_public_path__ + "static/media/datsun.59633543.png";